import { useEffect, useLayoutEffect } from 'react';
var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;
export default useIsomorphicLayoutEffect;



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/react-use/esm/useIsomorphicLayoutEffect.js
// module id = lAuu
// module chunks = 0